module.exports = __webpack_public_path__ + "media/customerVideo3.e64fbf0a.mp4";